import { useEffect, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AOS from "aos";
import NavScrollTop from "./components/NavScrollTop";
import AllRoutes from "./Routes";
import i18next from "./i18n";

import "./i18n";

i18next.t("my.key");

function App() {
  useEffect(() => {
    AOS.init({
      offset: 80,
      duration: 1000,
      once: true,
      easing: "ease",
    });
    AOS.refresh();
  }, []);

  return (
    <Router>
      <NavScrollTop>
        <Suspense fallback={<div />}>
          <AllRoutes />
        </Suspense>
      </NavScrollTop>
    </Router>
  );
}

export default App;
